"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobileLayout = exports.DesktopLayout = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const bind_1 = __importDefault(require("classnames/bind"));
const legacy_m_scss_1 = __importDefault(require("./legacy.m.scss"));
const cx = bind_1.default.bind(legacy_m_scss_1.default);
/**
 * Возвращает созданный функциональный компонент, формирующий Layout.
 * @param specificClass Специальный класс.
 * @param displayName Отображаемое имя компонента.
 * @return Элемент.
 */
const createLayout = (specificClass, displayName) => {
    const Component = (0, react_1.forwardRef)(({ className, element: Element = 'div', disabledOn = [], ...restProps }, ref) => ((0, jsx_runtime_1.jsx)(Element, { ...restProps, ref: ref, className: cx('layout', specificClass, className, disabledOn.map(key => `disabled-${key}`)) })));
    Component.displayName = displayName;
    return Component;
};
/**
 * @deprecated На адаптивных страницах стоит использовать Layout.
 */
const DesktopLayout = createLayout('desktop', 'DesktopLayout');
exports.DesktopLayout = DesktopLayout;
/**
 * @deprecated На адаптивных страницах стоит использовать Layout.
 */
const MobileLayout = createLayout('mobile', 'MobileLayout');
exports.MobileLayout = MobileLayout;
//# sourceMappingURL=legacy.js.map